const emptyChannels = {
    vk: '#',
    max: '#',
    site: '#',
    phone: 'tel:+70000000000',
    phoneLabel: '+7 (000) 000-00-00',
};
export const solutions = [
    {
        id: 'windows',
        slug: 'windows',
        label: '01',
        industry: 'Оконная компания',
        title: 'Агент для консультаций и записи на замер',
        shortDescription: 'Консультирует по окнам и услугам компании, уточняет задачу и записывает клиента на замер в удобное время.',
        description: 'ИИ-агент берёт на себя первое общение с клиентом: рассказывает об окнах, профилях, вариантах остекления и монтажа, отвечает на типовые вопросы и помогает подобрать подходящее решение. Затем собирает контакты, адрес и пожелания, согласовывает удобные дату и время замера и передаёт менеджеру готовую заявку.',
        points: ['Консультация по услугам', 'Сбор данных по заказу', 'Запись клиента на замер'],
        capabilities: [
            'Консультация по окнам, профилям, остеклению, монтажу и другим услугам компании',
            'Уточнение задачи, параметров объекта, адреса и контактных данных клиента',
            'Запись на замер: подбор свободного времени, подтверждение и передача заявки замерщику',
            'Работа 24/7 в VK, MAX, на сайте и по телефону с передачей сложных вопросов менеджеру',
        ],
        image: '/images/windows.jpg',
        imageAlt: 'Фасад современного здания с панорамным остеклением',
        partner: {
            name: 'ИТ Окна',
            url: 'https://www.itokna.ru',
            label: 'Партнёр по оконному направлению',
            logo: '/partners/itokna.png',
        },
        showDemo: true,
        demo: { ...emptyChannels },
        leads: { ...emptyChannels, site: '#contact' },
    },
    {
        id: 'fitness',
        slug: 'fitness',
        label: '02',
        industry: 'Фитнес-клуб',
        title: 'Агент для записи и общения с клиентами',
        shortDescription: 'Отвечает на вопросы о тарифах и расписании, помогает записаться на тренировку и снижает нагрузку на администраторов.',
        description: 'ИИ-агент берёт на себя первую линию общения клуба: рассказывает об абонементах, помогает выбрать услугу, записывает на тренировку и передаёт сложные вопросы администратору. Работает в привычных каналах клиента — без установки приложений.',
        points: ['Запись и перенос визитов', 'Ответы о абонементах и услугах', 'Квалификация входящих обращений'],
        capabilities: [
            'Консультация по тарифам, расписанию и услугам клуба',
            'Запись, перенос и отмена тренировок',
            'Сбор контактов и передача тёплых заявок менеджеру',
            'Работа 24/7 в мессенджерах, на сайте и по телефону',
        ],
        image: '/images/fitness.jpg',
        imageAlt: 'Тренировочный зал фитнес-клуба',
        partner: {
            name: 'Проффит',
            url: 'https://www.fitnessoft.ru',
            label: 'Партнёр по фитнес-направлению',
            logo: '/partners/proffit.png',
        },
        showDemo: true,
        demo: { ...emptyChannels },
        leads: { ...emptyChannels, site: '#contact' },
    },
    {
        id: 'custom',
        slug: 'custom',
        label: '03',
        industry: 'Под ваши задачи',
        title: 'Агент, собранный под ваш процесс',
        shortDescription: 'Разработаем ИИ-агента именно под ваши сценарии: продажи, сервис, запись, квалификация лидов и внутренние задачи.',
        description: 'Если готовые отраслевые решения не закрывают задачу полностью — соберём агента с нуля под ваш бизнес. Разберём процессы, каналы и интеграции, спроектируем сценарии общения и запустим агента, который говорит языком вашей компании и передаёт заявки туда, куда вам удобно.',
        points: [
            'Сценарии под ваш продукт и тон общения',
            'Подключение нужных каналов и CRM',
            'Запуск, обучение и сопровождение',
        ],
        capabilities: [
            'Проектирование агента под ваши роли, продукты и регламенты',
            'Интеграция с сайтом, мессенджерами, телефонией и CRM',
            'Квалификация лидов, запись, консультации, поддержка — по вашему ТЗ',
            'Доработка сценариев после запуска на реальных диалогах',
        ],
        image: '/images/hero.jpg',
        imageAlt: 'Команда обсуждает бизнес-процессы',
        showDemo: false,
        demo: { ...emptyChannels },
        leads: { ...emptyChannels, site: '#contact' },
    },
];
export function getSolutionBySlug(slug) {
    return solutions.find((item) => item.slug === slug);
}
